import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBullHorn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.24016 17.3798C8.34308 17.5915 8.25965 17.8489 8.05383 17.9548C7.99597 17.9845 7.93217 18 7.86749 18H5.20833C4.97822 18 4.79167 17.8081 4.79167 17.5714L3.54167 11.6462H2.5C1.11929 11.6462 0 10.495 0 9.07479V6.50336C0 5.08321 1.11929 3.93193 2.5 3.93193H6.04167V11.6464L8.24016 17.3798ZM17.484 0.317844C17.4946 0.356982 17.5 0.397489 17.5 0.438194V14.9905C17.5 15.2324 17.3135 15.4286 17.0833 15.4286C17.0446 15.4286 17.0061 15.4229 16.9689 15.4117L7.29167 11.7857V3.64286L16.9689 0.0169684C17.1901 -0.0494991 17.4207 0.0852074 17.484 0.317844ZM19.5833 5.8605C19.8135 5.8605 20 6.05239 20 6.28908V9.28908C20 9.52578 19.8135 9.71764 19.5833 9.71764H18.75V5.8605H19.5833Z",
		fill: "currentColor"
	})
});
export default SvgBullHorn;
